/* eslint-disable import/no-unresolved */
import { useEffect, useState } from 'react';

import { buildConfig } from 'views/DataRecon/DataConfiguration/containers/reconciliationtype/utils';
import DataSuggestionModal from '../components/DataSuggestionModal';

const DataSuggestionContainer = ({
    showSuggestionModal, setShowSuggestionModal, selectedOperation, setSelectedOperation,
    configData, reconNodeId, setFlowConfig, setIsConfigBuilding, selectedRelation, navigateToConfigPage, projectConfig,
}) => {
    const [updatedConfigData, setUpdatedConfigData] = useState(configData || []);
    const [sourceCol, setSourceCol] = useState(selectedRelation.sourceCol || '');
    const [targetCol, setTargetCol] = useState(selectedRelation.targetCol || '');
    const [sourceGroupBy, setSourceGroupBy] = useState(selectedRelation.sourceGroupByCol ? selectedRelation.sourceGroupByCol.split(',') : []);
    const [targetGroupBy, setTargetGroupBy] = useState(selectedRelation.targetGroupByCol ? selectedRelation.targetGroupByCol.split(',') : []);
    const [showWarningModal, setShowWarningModal] = useState(false);
    const [confirm, setConfirm] = useState(false);
    const [isNavigateForAnotherFun, setIsNavigateForAnotherFun] = useState(false);

    const isConfigAvailable = projectConfig.data && projectConfig.data.getChildProjectsConfiguration.projectConfig.flowConfig;

    /* callback called when operation is selected */
    const onSelectOperation = e => setSelectedOperation(e);

    /* callback called when source column is selected */
    const onSourceColSelected = e => {
        setSourceCol(e);
        setUpdatedConfigData(prevState => {
            const data = [...prevState];
            const updateData = data[0].selectedColumns.map(sc => (
                sc.column === e ? { ...sc, isSourceColumn: true } : { ...sc, isSourceColumn: false }
            ));
            data[0].selectedColumns = updateData;
            return data;
        });
    };

    /* callback called when target column is selected */
    const onTargetColSelected = e => {
        setTargetCol(e);
        setUpdatedConfigData(prevState => {
            const data = [...prevState];
            const updateData = data[1].selectedColumns.map(sc => (
                sc.column === e ? { ...sc, isTargetColumn: true } : { ...sc, isTargetColumn: false }
            ));
            data[1].selectedColumns = updateData;
            return data;
        });
    };

    /* callback called when source group by is selected */
    const onSourceGroupBySelected = e => {
        setSourceGroupBy(e);
        setUpdatedConfigData(prevState => {
            const data = [...prevState];
            const updateData = data[0].selectedColumns.map(sc => (
                e.includes(sc.column) ? { ...sc, isSourceGroupBy: true } : { ...sc, isSourceGroupBy: false }
            ));
            data[0].selectedColumns = updateData;
            return data;
        });
    };

    /* callback called when target group by is selected */
    const onTargetGroupBySelected = e => {
        setTargetGroupBy(e);
        setUpdatedConfigData(prevState => {
            const data = [...prevState];
            const updateData = data[1].selectedColumns.map(sc => (
                e.includes(sc.column) ? { ...sc, isTargetGroupBy: true } : { ...sc, isTargetGroupBy: false }
            ));
            data[1].selectedColumns = updateData;
            return data;
        });
    };

    /* function to build configuration for selected operation */
    const buildFlowConfig = () => {
        if (updatedConfigData.length > 0) {
            const flowConfig = buildConfig(updatedConfigData, selectedOperation, sourceGroupBy, targetGroupBy);
            const flow = {
                sourceRoundUp: '',
                targetRoundUp: '',
                ...flowConfig,
            };
            const config = {
                [reconNodeId]: { ...flow },
            };
            setFlowConfig(prevState => ({
                ...prevState,
                ...config,
            }));
        }
    };

    /* callback called when Save button is clicked */
    const handleConfirm = value => {
        // build flow config and save the config
        setIsConfigBuilding(true);
        buildFlowConfig();
        if (isConfigAvailable) {
            setShowWarningModal(true);
        } else {
            setShowWarningModal(false);
            setConfirm(true);
        }
        if (value) {
            setIsNavigateForAnotherFun(true);
        } else {
            setIsNavigateForAnotherFun(false);
        }
    };

    /** side effect when confirm is changed */
    useEffect(() => {
        // When recon function is Sum
        if ((confirm === true) && isNavigateForAnotherFun === false) {
            navigateToConfigPage();
        }
        // When recon function is other than Sum
        if (isNavigateForAnotherFun === true) {
            navigateToConfigPage(isNavigateForAnotherFun);
        }
    }, [confirm]);

    /** side effect when source col is changed */
    useEffect(() => {
        setUpdatedConfigData(prevState => {
            const data = [...prevState];
            const updateData = data[0].selectedColumns.map(sc => (
                sc.column === sourceCol ? { ...sc, isSourceColumn: true } : { ...sc, isSourceColumn: false }
            ));
            data[0].selectedColumns = updateData;
            return data;
        });
    }, [sourceCol]);
    /** side effect when target col is changed */
    useEffect(() => {
        setUpdatedConfigData(prevState => {
            const data = [...prevState];
            const updateData = data[1].selectedColumns.map(sc => (
                sc.column === targetCol ? { ...sc, isTargetColumn: true } : { ...sc, isTargetColumn: false }
            ));
            data[1].selectedColumns = updateData;
            return data;
        });
    }, [targetCol]);
    /** side effect when source group by col is changed */
    useEffect(() => {
        setUpdatedConfigData(prevState => {
            const data = [...prevState];
            const updateData = data[0].selectedColumns.map(sc => (
                sourceGroupBy.includes(sc.column) ? { ...sc, isSourceGroupBy: true } : { ...sc, isSourceGroupBy: false }
            ));
            data[0].selectedColumns = updateData;
            return data;
        });
    }, [sourceGroupBy]);
    /** side effect when target group col is changed */
    useEffect(() => {
        setUpdatedConfigData(prevState => {
            const data = [...prevState];
            const updateData = data[1].selectedColumns.map(sc => (
                targetGroupBy.includes(sc.column) ? { ...sc, isTargetGroupBy: true } : { ...sc, isTargetGroupBy: false }
            ));
            data[1].selectedColumns = updateData;
            return data;
        });
    }, [targetGroupBy]);

    return (
        <DataSuggestionModal
            showSuggestionModal={showSuggestionModal}
            setShowSuggestionModal={setShowSuggestionModal}
            selectedOperation={selectedOperation}
            selectedRelation={selectedRelation}
            updatedConfigData={updatedConfigData}
            sourceCol={sourceCol}
            targetCol={targetCol}
            sourceGroupBy={sourceGroupBy}
            targetGroupBy={targetGroupBy}
            showWarningModal={showWarningModal}
            onSelectOperation={onSelectOperation}
            onSourceColSelected={onSourceColSelected}
            onTargetColSelected={onTargetColSelected}
            onSourceGroupBySelected={onSourceGroupBySelected}
            onTargetGroupBySelected={onTargetGroupBySelected}
            setConfirm={setConfirm}
            handleConfirm={handleConfirm}
            setShowWarningModal={setShowWarningModal}
        />
    );
};

export default DataSuggestionContainer;
